import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;

import Models from './Models';
import Form from './Form';
import Field from './Field';
import Fields from './Fields';
import Entry from './Entry';
import Entries from './Entries';

export default class Forms extends Models {

    constructor(...models) {
        super(...models);
    }

    async store() {
        for (let form of this) {
            await Storage.set({
                key: `forms/${form.id}`,
                value: JSON.stringify(form)
            });
        }
    }

    static async restore(search="", offset=0, limit=10) {
        let forms = new Forms();
        let keys = await Storage.keys();
        let keysFiltered = keys.keys.filter(key => key.startsWith(`forms/`)).sort();
        for (let key of keysFiltered) {
            const item = await Storage.get({ key: key });
            let json = JSON.parse(item.value);
            let form = new Form(json);
            if (search === "" || form.title.toLowerCase().startsWith(search.toLowerCase())) {
                if (forms.length < offset+limit) {
                    let fields = new Fields();
                    for (let _field of json.fields) {
                        let field = new Field(_field);
                        fields.push(field);
                    }
                    form.fields = fields.sortAsc("ordinal");
                    let entries = new Entries();
                    for (let _entry of json.entries) {
                        let entry = new Entry(_entry);
                        entries.push(entry);
                    }
                    form.entries = entries.sortAsc("ordinal");
                    forms.push(form);
                }
                else {
                    break;
                }
            }
        }
        return forms;
    }

    static async load(search="", offset=0, limit=10) {
        let forms = new Forms();
        let user = firebase.auth().currentUser;
        let ref = firebase.firestore().collection("forms");
        let queries = [
            ref.where("user", "==", user.uid).orderBy("created", "desc").limit(offset+limit),
            ref.where("writers", "array-contains", user.email).orderBy("created", "desc").limit(offset+limit),
            ref.where("readers", "array-contains", user.email).orderBy("created", "desc").limit(offset+limit)
        ];
        for (let query of queries) {
            let snapshot = await query.get();
            snapshot.forEach(async doc => {
                let filtered = forms.filter((form) => form.id == doc.id);
                if (filtered == undefined || filtered == null || filtered.length == 0) {
                    let data = doc.data();
                    if (data.title.toLowerCase().startsWith(search.toLowerCase())) {
                        if (forms.length < offset+limit) {
                            let form = new Form({
                                id: doc.id,
                                key: data.key,
                                url: data.url,
                                title: data.title,
                                user: data.user,
                                email: data.email, 
                                author: data.author,
                                created: data.created,
                                updated: data.updated,
                                description: data.description,
                                writer: data.writers.includes(user.email),
                                reader: data.readers.includes(user.email),
                                owner: (data.user === user.uid) || (data.owner === user.email)
                            });
                            let fields = new Fields();
                            let items = await ref.doc(doc.id).collection("fields").orderBy("ordinal", "asc").get();
                            items.forEach(item => {
                                let data = item.data();
                                let field = new Field({
                                    id: item.id,
                                    title: data.title,
                                    type: data.type,
                                    icon: data.icon,
                                    ordinal: data.ordinal,
                                    required: data.required,
                                    options: data.options || []
                                });
                                fields.push(field);
                            });
                            form.fields = fields.sortAsc("ordinal");
                            forms.push(form);
                        }
                    }
                }
            });
        }
        return forms;
    }

    static async pending(search="", offset=0, limit=10) {
        let forms = new Forms();
        let keys = await Storage.keys();
        let filtered = keys.keys.filter(key => key.startsWith(`forms/`));
        for (let key of filtered) {
            const item = await Storage.get({ key: key });
            let json = JSON.parse(item.value);
            let form = new Form(json);
            if (form.pending && form.title.toLowerCase().startsWith(search.toLowerCase())) {
                if (forms.length < offset+limit) {
                  form.fields = new Fields();
                  for (let _field of json.fields) {
                      let field = new Field(_field);
                      field.options = _field.options.flat();
                      form.fields.push(field);
                  }
                  form.entries = new Entries();
                  for (let _entry of json.entries) {
                      let entry = new Entry(_entry);
                      form.entries.push(entry);
                  }
                  form.entries = form.entries.sortAsc("ordinal");
                  forms.push(form);
                }
            }
        }
        return forms;
    }

    static async pendingCount() {
        let count = 0;
        let keys = await Storage.keys();
        for (let key of keys.keys) {
            if (key.startsWith("forms/")) {
                const item = await Storage.get({ key: key });
                let json = JSON.parse(item.value);
                let form = new Form(json);
                if (form.pending) {
                    count = count + 1;
                }
            }
        }
        return count;
    }

}